import { motion } from "framer-motion";

export const ScrollReveal = ({
  children,
  className = "",
  delay = 0,
  y = 40,
  duration = 0.8,
}) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};
